
import { useMemo } from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

interface UseCalendarDynamicTextProps {
  checkInDate?: Date;
  checkOutDate?: Date;
}

export const useCalendarDynamicText = ({ checkInDate, checkOutDate }: UseCalendarDynamicTextProps) => {
  return useMemo(() => {
    const getDynamicTitle = () => {
      if (checkInDate && checkOutDate) {
        const nights = Math.ceil((checkOutDate.getTime() - checkInDate.getTime()) / (1000 * 60 * 60 * 24));
        return `${nights} ${nights === 1 ? 'noche' : 'noches'} en Manzanillo`;
      }
      return "Selecciona las fechas";
    };

    const getDynamicSubtext = () => {
      if (!checkInDate && !checkOutDate) {
        return "Ingresa tus fechas para ver el precio exacto";
      }
      
      if (checkInDate && checkOutDate) {
        return `${format(checkInDate, "d 'de' MMM. 'de' yyyy", { locale: es })} - ${format(checkOutDate, "d 'de' MMM. 'de' yyyy", { locale: es })}`;
      }
      
      return "Selecciona tu fecha de salida";
    };

    return {
      title: getDynamicTitle(),
      subtext: getDynamicSubtext()
    };
  }, [checkInDate, checkOutDate]);
};
